const STAGES = [
  {
    time: "09:20",
    phase: "发酵",
    title: "首条切片流出，弹幕当场炸出「这也太敢了」",
    note: "某直播片段在瓜田被四处转发，前排围观玩家率先下场考古背景资料。",
    heat: "+12%",
  },
  {
    time: "11:40",
    phase: "放大",
    title: "话题冲上热榜，官方词条下涌进第一波讨论",
    note: "广场热度急升，立场对立的帖子开始互相点名，风向逐渐分裂成两拨。",
    heat: "+9%",
  },
  {
    time: "14:05",
    phase: "回应",
    title: "当事人 / 节目组先后发声，措辞细节被逐句分析",
    note: "声明一出，网友立刻开工逐句核对时间线，评论区开启「真相竞速」。",
    heat: "+7%",
  },
  {
    time: "17:30",
    phase: "反转",
    title: "更多现场素材被扒出，舆论风向再度掉头",
    note: "新一轮「实锤」让风向再度反转，围观玩家开始排队为早前立场复盘。",
    heat: "+5%",
  },
];

const PHASE_COLOR: Record<string, string> = {
  发酵: "bg-secondary-100 text-secondary-700",
  放大: "bg-primary-100 text-primary-700",
  回应: "bg-secondary-100 text-secondary-700",
  反转: "bg-accent-100 text-accent-700",
};

export default function Timeline() {
  return (
    <section id="timeline" className="border-t border-background-200/70 bg-background-100/50 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] gap-6 lg:gap-10">
        {/* 左：说明卡 */}
        <div className="lg:sticky lg:top-24 h-fit">
          <div className="rounded-2xl bg-gradient-to-br from-primary-600 to-accent-600 text-background-50 p-6 md:p-8">
            <span className="flex items-center gap-2 w-fit rounded-full bg-background-50/20 text-xs font-bold px-3 py-1">
              <i className="ri-time-line" aria-hidden="true"></i> 事件时间线
            </span>
            <h2 className="font-display font-black text-background-50 text-2xl md:text-3xl mt-4 leading-snug">一个瓜的<br />标准发酵流程</h2>
            <p className="mt-4 text-background-50/85 text-sm leading-relaxed">
              从片段流出到官媒回应，再到风向反转，追同一根线你才不会漏掉任何一个关键转折点。
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {["发酵", "放大", "回应", "反转"].map((p) => (
                <span key={p} className="rounded-full bg-background-50 text-primary-700 text-[11px] font-bold px-3 py-1">{p}</span>
              ))}
            </div>
          </div>
        </div>

        {/* 右：纵向时间轴 */}
        <div className="relative flex flex-col">
          <span className="absolute left-[15px] md:left-[17px] top-2 bottom-2 w-px bg-background-300"></span>
          {STAGES.map((s, i) => (
            <div key={s.time} className="relative pl-12 md:pl-14 pb-6 md:pb-7 last:pb-0">
              <span className="absolute left-[10px] md:left-[12px] top-1 w-[11px] h-[11px] rounded-full bg-background-50 ring-2 ring-primary-500 flex items-center justify-center">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              </span>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-display font-bold text-primary-600 text-lg">{s.time}</span>
                <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${PHASE_COLOR[s.phase]}`}>{s.phase}</span>
                <span className="flex items-center gap-1 text-[11px] text-accent-600 font-medium">
                  <i className="ri-arrow-up-line" aria-hidden="true"></i> 热度 {s.heat}
                </span>
              </div>
              <h3 className="mt-2 font-semibold text-foreground-950 text-[15px] leading-snug">{s.title}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed max-w-2xl">{s.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}